export default __webpack_public_path__ + "static/media/2627 cutlery side.651f329b.png";